











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { QuestionFileModel } from "survey-core";
@Component
export class FileVideo extends Vue {
  @Prop() question: QuestionFileModel;
}
Vue.component("sv-file-video", FileVideo);
export default FileVideo;
